import React from 'react';
import { AGGREGATE } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';
import { sortBy } from 'lodash-es';
import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

import styles from './ReportingFormFive.module.scss';

const formatNumber = (num: number, type?: string): string => {
  const numDigits = !!type && type.includes('numeric') ? type.replace(/[^0-9,]/g, '').split(',') : undefined;
  if (Number.isNaN(num)) {
    return '';
  }

  const initNum = numDigits && !Number.isNaN(numDigits[1]) ? num.toFixed(parseInt(numDigits[1])) : num;

  return initNum
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    .replace('.', ',');
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const generateColumns = (cols): ColumnInterface[] => {
  let columnOrder = 1;
  return sortBy(cols, ['orderNo']).map((col) => {
    const newCol = {
      orderNo: col.orderNo,
      label: `${columnOrder}`,
      key: `${col.columnName}`,
      type: col.dataType,
      title: col.columnComment,
      width: 250,
      aggregate: col.isSummation ? AGGREGATE.SUM : undefined,
      aggregateRender: col.isSummation
        ? ({ value }) => (
            <div className={styles.aggregation}>
              {typeof value === 'number' ? formatNumber(value, col.dataType) : value}
            </div>
          )
        : undefined,
      hidden: !col.displaySign,
      hiddenInSettings: !col.displaySign,
      render: ({ value }) => (typeof value === 'number' ? formatNumber(value, col.dataType) : value),
    };

    if (col.displaySign) {
      columnOrder++;
    }

    return newCol;
  });
};
